import { useKpis } from '@/api/reports';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { EmptyState } from '@/components/shared/empty-state';
import { cn } from '@/lib/utils';
import { BarChart3, Users, BookOpen, Award, AlertTriangle, TrendingUp } from 'lucide-react';

export function KpisSection() {
  const { data: kpis, isLoading, error } = useKpis();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message="No se pudieron cargar los KPIs." />;
  if (!kpis) return <EmptyState title="Sin datos" description="No hay datos disponibles." />;

  const cards = [
    {
      label: 'Cursos Publicados',
      value: kpis.total_published_courses,
      icon: BookOpen,
      color: 'text-blue-600 bg-blue-100',
    },
    {
      label: 'Inscripciones',
      value: kpis.total_enrollments,
      icon: Users,
      color: 'text-purple-600 bg-purple-100',
    },
    {
      label: 'Tasa Completacion',
      value: `${kpis.completion_rate}%`,
      icon: TrendingUp,
      color: 'text-green-600 bg-green-100',
    },
    {
      label: 'Vencidos',
      value: kpis.expired_enrollments,
      icon: AlertTriangle,
      color: 'text-red-600 bg-red-100',
    },
    {
      label: 'Acc. Correctivas',
      value: kpis.active_corrective_actions,
      icon: BarChart3,
      color: 'text-amber-600 bg-amber-100',
    },
    {
      label: 'Certificados',
      value: kpis.total_certificates_issued,
      icon: Award,
      color: 'text-teal-600 bg-teal-100',
    },
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {cards.map((card) => (
        <div key={card.label} className="rounded-xl border border-border bg-card p-5">
          <div className="flex items-center gap-3">
            <div
              className={cn('flex h-10 w-10 items-center justify-center rounded-full', card.color)}
            >
              <card.icon className="h-5 w-5" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">{card.label}</p>
              <p className="text-2xl font-bold text-card-foreground">{card.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
